import { Iso8601DateString } from '@connect-x-app/shared-types';

export type Message = {
  account?: string;
  attachments: MessageAttachment[];
  channelId: string;
  createdAt: Iso8601DateString;
  externalId?: string;
  id: string;
  level: SystemMessageLevel | null;
  mentions: MessageMention[] | null;
  pendingImage?: File & { uri?: string }; // INTERNALLY ONLY
  receipts: MessageReceipt[];
  room: string;
  status: MessageStatus | null;
  text: string;
  type: MessageTypes;
  user: string | null;
  visibility: MessageVisibility;
};

export enum MessageVisibility {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
}

export enum MessageTypes {
  SYSTEM = 'SYSTEM',
  USER = 'USER',
}

export enum SystemMessageLevel {
  ACCENT = 'ACCENT',
  ATTENTION = 'ATTENTION',
  CAUTION = 'CAUTION',
  IMPORTED = 'IMPORTED',
  OK = 'OK',
  UNCLEAR = 'UNCLEAR',
  UNKNOWN = 'UNKNOWN',
  WARNING = 'WARNING',
}

export type MessageAttachment = {
  externalId?: string;
  id: string;
  name: string;
  type: string;
};

export type MessageReceipt = {
  status: MessageStatus;
  updatedAt: Iso8601DateString;
  user: string;
};

export enum MessageStatus {
  DELIVERED = 'DELIVERED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  READ = 'READ',
  SENT = 'SENT',
}

export type MessageMention = {
  label: string;
  roles?: string[];
  type: MessageMentionType;
  users?: string[];
};

export enum MessageMentionType {
  CREW_ROLE = 'CREW_ROLE',
  DISPLAY_NAME = 'DISPLAY_NAME',
  USER_NAME = 'USER_NAME',
}
